import CancelIcon from "@mui/icons-material/Cancel";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  Box,
  Card,
  CardActions,
  Collapse,
  IconButton,
  InputAdornment,
  InputLabel,
  Paper,
  TextField,
} from "@mui/material";
import { CustomContentProps, SnackbarContent, useSnackbar } from "notistack";
import React, { forwardRef, useCallback, useState } from "react";

import { CopyButton } from "new-components/buttons/CopyButton";
import { Typography } from "new-components/typography/Typography";

interface ErrorSnackbarProps extends CustomContentProps {
  errorString?: string;
  errorCount?: number;
}

const ErrorSnackbar = forwardRef<HTMLDivElement, ErrorSnackbarProps>(
  ({ id, errorString, errorCount, ...props }, ref) => {
    const { closeSnackbar } = useSnackbar();
    const [expanded, setExpanded] = useState(false);

    const handleExpandClick = useCallback(() => {
      setExpanded((oldExpanded) => !oldExpanded);
    }, []);

    return (
      <Box
        ref={ref}
        sx={{
          width: { sm: "650px" },
        }}
      >
        <SnackbarContent>
          <Card sx={{ width: "100%", backgroundColor: "#D32F2F", color: "#FFFFFF" }}>
            <CardActions
              sx={{
                padding: "8px 8px 8px 16px",
                justifyContent: "space-between",
              }}
            >
              <IconButton className="text-white" onClick={() => closeSnackbar(id)}>
                <CancelIcon />
              </IconButton>
              <Typography className="p-2">
                {props.message}
              </Typography>
              <Box>
                <IconButton
                  aria-label="Show more"
                  size="small"
                  sx={{
                    transform: expanded ? "rotate(180deg)" : "rotate(0deg)",
                    transition: "all .2s",
                  }}
                  className="text-white mx-0 p-2"
                  onClick={handleExpandClick}
                >
                  <ExpandMoreIcon />
                </IconButton>
              </Box>
            </CardActions>
            <Collapse in={expanded} timeout="auto" unmountOnExit>
              <Paper sx={{ backgroundColor: "#fff", padding: 2 }}>
                <Box>
                  <InputLabel className="uppercase text-sm text-neutral-700 font-bold mb-2">Error trace:</InputLabel>
                  <TextField
                    value={errorString}
                    multiline
                    rows={6}
                    InputProps={{
                      className: "rounded py-2 px-2",
                      endAdornment: (
                        <InputAdornment position="end">
                          <CopyButton valueToCopy={errorString || ""} />
                        </InputAdornment>
                      ),
                      style: { padding: 0, backgroundColor: "#F2F5F6" },
                    }}
                    disabled
                    fullWidth
                  />
                </Box>
              </Paper>
            </Collapse>
          </Card>
        </SnackbarContent>
      </Box>
    );
  }
);

ErrorSnackbar.displayName = "ErrorSnackbar";

export default ErrorSnackbar;
